import { createAction } from 'redux-actions';
import { Gruser, PapiGruserPage } from '../../types/papi';
import { ZoneName } from '../../types/zones';
import { ModuleName } from '../../types/modules';

export const fetchLayoutSuccess = createAction(
  '@@gruser.LAYOUT.FETCH.SUCCESS',
  (gruser: Gruser, payload: PapiGruserPage['layout']) => ({
    ...payload,
    gruser,
  })
);

export type MoveModuleActionPayload = {
  zoneName: ZoneName;
  moduleId: number;
  position: number;
};

export const moveModule = createAction(
  '@@gruser.LAYOUT.MOVE_MODULE',
  (gruser: Gruser, payload: MoveModuleActionPayload) => ({
    ...payload,
    gruser,
  })
);

export type RemoveModuleActionPayload = {
  zoneName: ZoneName;
  moduleId: number;
};

export const removeModule = createAction(
  '@@gruser.LAYOUT.REMOVE_MODULE',
  (gruser: Gruser, payload: RemoveModuleActionPayload) => ({
    ...payload,
    gruser,
  })
);
export const removeModuleSuccess = createAction(
  '@@gruser.LAYOUT.REMOVE_MODULE_SUCCESS',
  (gruser: Gruser, payload: RemoveModuleActionPayload) => ({
    ...payload,
    gruser,
  })
);

export type UpdateModuleOrderActionPayload = {
  zoneName: ZoneName;
  order: number[];
  version?: number;
};

export const updateModuleOrderSuccess = createAction(
  '@@gruser.LAYOUT.UPDATE_MODULE_ORDER.SUCCESS',
  (gruser: Gruser, payload: UpdateModuleOrderActionPayload) => ({
    ...payload,
    gruser,
  })
);

export type AddModuleActionPayload = {
  zoneName: ZoneName;
  moduleName: ModuleName;
  position: number;
};

export const addModule = createAction(
  '@@gruser.LAYOUT.ADD_MODULE',
  (gruser: Gruser, payload: AddModuleActionPayload) => ({
    ...payload,
    gruser,
  })
);

export const addModuleSuccess = createAction(
  '@@gruser.LAYOUT.ADD_MODULE_SUCCESS',
  (gruser: Gruser, payload: AddModuleActionPayload) => ({
    ...payload,
    gruser,
  })
);

export const addModuleFail = createAction(
  '@@gruser.LAYOUT.ADD_MODULE_FAIL',
  (gruser: Gruser, payload: AddModuleActionPayload) => ({
    ...payload,
    gruser,
  })
);

export type LayoutVersionPayload = {
  version: number;
};

export const updateLayoutVersion = createAction(
  '@@gruser.LAYOUT.UPDATE_VERSION',
  (gruser: Gruser, payload: LayoutVersionPayload) => ({
    ...payload,
    gruser,
  })
);
